import { render, staticRenderFns } from "./packagecalc.vue?vue&type=template&id=65f8a2c6&scoped=true"
import script from "./packagecalc.vue?vue&type=script&lang=js"
export * from "./packagecalc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f8a2c6",
  null
  
)

export default component.exports